export default __webpack_public_path__ + "static/media/READY TO GO.2f7c44d5.png";